import React, { useRef, useState } from "react";
import { MapContainer, Popup, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import Location from "./Location.ts";
import config from "../config.ts";
import MapClickHandler from "./MapClickHandler.tsx";
import ChangeMapBounds from "./ChangeView.tsx";
import MarkerClickedPopup from "./MarkerClickedPopup.tsx";
import RouteLayer from "./RouteLayer.tsx";
import { ColouredMarker, MarkerColour } from "./ColouredMarker.tsx";

const TravelTimeMap = ({
  addLoc,
  changeView,
  setChangeView,
  locations,
  CircleLayer,
  routes,
  routeDest,
  showRoute,
  highlightedSection,
}) => {
  const [clickedLoc, setClickedLoc] = useState<Location | null>(null);

  const popupRef = useRef(null);

  const handleMapClick = (e) => {
    var { lat, lng } = e.latlng;
    const latLongString = `(${lat.toFixed(4)}, ${lng.toFixed(4)})`;
    const loc = new Location(latLongString, [lat, lng]);
    setClickedLoc(loc);
  };

  const handleMarkerClick = (e) => {
    // Need a delay here because the popup has some internal onclick logic that breaks
    // when we remove the popup from the dom.
    setTimeout(() => {
      setClickedLoc(null);
    }, 20);
  };

  return (
    <MapContainer
      bounds={config.startingBounds}
      scrollWheelZoom={true}
      zoomControl={false}
      preferCanvas={true}
      wheelPxPerZoomLevel={config.wheelPxPerZoomLevel}
    >
      {
        <ChangeMapBounds
          locations={locations}
          changeView={changeView}
          setChangeView={setChangeView}
        />
      }
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
      />
      {CircleLayer}
      {routes.length > 0 && (
        <RouteLayer routes={routes} highlight={highlightedSection} />
      )}
      {locations.map((l, i) => (
        <ColouredMarker
          position={l.coords}
          key={i.toString()}
          colour={MarkerColour.blue}
        />
      ))}
      {routeDest && (
        <ColouredMarker
          position={routeDest.coords}
          colour={MarkerColour.violet}
        />
      )}

      {clickedLoc && (
        <ColouredMarker
          position={clickedLoc.coords}
          colour={MarkerColour.grey}
          eventHandlers={{ click: handleMarkerClick }}
        >
          <Popup closeOnClick={true} closeButton={false} ref={popupRef}>
            <MarkerClickedPopup
              location={clickedLoc}
              addLoc={() => {
                addLoc(clickedLoc);
              }}
              onShowRoute={
                locations.length > 0
                  ? () => {
                      showRoute(clickedLoc);
                      handleMarkerClick(null);
                    }
                  : undefined
              }
              onPopupClick={handleMarkerClick}
              className="!bg-green-500"
            />
          </Popup>
        </ColouredMarker>
      )}
      {<MapClickHandler onClick={handleMapClick} />}
    </MapContainer>
  );
};

export default TravelTimeMap;
